/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponseData;

  constructor(
    err:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse";
  }
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse(
        v,
      );
    });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse
  > = z.instanceof(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsErrorResponse$Outbound;
}
